// ══════════════════════════════════════════════════════════════
// COMPASS – Custom Toast Component (ngx-toastr overlay)
// ══════════════════════════════════════════════════════════════
import {
  Component,
  HostBinding,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Toast } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { NotificationType } from '../../notification.model';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('300ms ease-in')),
      transition('active => removed', animate('300ms ease-out')),
    ]),
  ],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.scss',
})
export class CustomToastComponent extends Toast {
  notificationType: NotificationType = 'info';
  actionLabel = '';
  actionCallback: (() => void) | null = null;
  showCloseButton = true;

  /** Alias – Toast.title is a Signal in ngx-toastr v19+ */
  get toastTitle(): string {
    return this.title();
  }

  get toastMessage(): string {
    return this.message();
  }

  @HostBinding('@flyInOut')
  get animationState(): string {
    return this.state();
  }

  get iconName(): string {
    const icons: Record<NotificationType, string> = {
      success: 'check_circle',
      info: 'info',
      error: 'error',
      warning: 'warning',
    };
    return icons[this.notificationType];
  }

  onAction(event: Event): void {
    event.stopPropagation();
    if (this.actionCallback) {
      this.actionCallback();
    }
    this.remove();
  }
}
